export default "__VITE_ASSET__BQnWAEF1__";